import React, { memo, useCallback } from "react";
import Combobox from "@ls/react-combobox-grid";
import { useDispatch, useSelector } from "react-redux";
import {
  //   selectModeValue,
  selectScenarioValue,
  selectSideBySideValue,
} from "state/selections/selectors";
import { setScenariosValue, setSideBySide } from "state/selections/actions";
import SelectionState from "state/selections/SelectionState";
import Switch from "@ls/react-switch";
import styled from "styled-components";
import ToolTip from "@ls/react-tooltip";
// import Mode from 'state/selections/Mode';
import {
  selectFetchingScenarioOptions,
  selectScenarioOptions,
} from "state/scenario/selector";

const StyledSwitch = styled(Switch)`
  margin: 0 0 0 10px;
  width: 9em;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 3px;
  padding: 5px 3px;
  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.25);
  }
`;
const ScenarioSelector = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectFetchingScenarioOptions);
  const options = useSelector(selectScenarioOptions);

  const value = useSelector(selectScenarioValue(SelectionState.UNCOMMITTED));
  const onChange = useCallback(
    (value) => dispatch(setScenariosValue(value)),
    [dispatch]
  );
  const sideBySideValue = useSelector(
    selectSideBySideValue(SelectionState.UNCOMMITTED)
  );
  const onChangeSideBySide = useCallback(
    (value) => {
      dispatch(setSideBySide(value));
    },
    [dispatch]
  );

  return (
    <Combobox
      placeholder="Scenarios..."
      options={options}
      onChange={onChange}
      value={value}
      label="Scenario: "
      loading={loading}
      variation={1}
      tooltip={`${"(Optional) "}Select scenario to apply.`}
      componentR={
        <ToolTip
          label={`Toggle side by side view of columns before and after applying the selected scenario.`}
        >
          <div>
            <StyledSwitch
              onChange={onChangeSideBySide}
              value={sideBySideValue}
              //disabled={!value?.length}
              label="Side by Side"
            />
          </div>
        </ToolTip>
      }
    />
  );
};

export default memo(ScenarioSelector);
